import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import StrategicTension from "@/components/landing/StrategicTension";
import Product from "@/components/landing/Product";
import Process from "@/components/landing/Process";
import Confidentiality from "@/components/landing/Confidentiality";
import Disclaimer from "@/components/landing/Disclaimer";
import EarlyAccessForm from "@/components/landing/EarlyAccessForm";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#f3efe6] text-stone-900">
      <Navbar />
      <Hero />
      <Problem />
      <StrategicTension />
      <Product />
      <Process />
      <Confidentiality />
      <Disclaimer />
      <EarlyAccessForm />
      <FAQ />
      <Footer />
    </main>
  );
}
